import { ActionType, ProColumns } from '@ant-design/pro-components';
import { DatePicker, Form } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import * as Icon from 'base/ui/components/Icons';
import { Filter } from 'base/ui/components/Icons';
import dayjs from 'dayjs';
import usePartialState from 'hooks/usePartialState';
import { cloneDeep } from 'lodash';
import { observer } from 'mobx-react';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { SearchModel } from 'pages/model';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonModel } from 'services/Main/common_services';
import { ReportDetailRateVisitCustomerModel } from 'services/Main/reportVisitCustomerSR';
import { commonPresenter, commonStore, reportVisitCustomerSRPresenter, reportVisitCustomerSRStore } from 'stores/root_store';
import { DATE_FORMAT_POST, PAGE_SIZE_DEFAULT, VARIABLE_CHECK_ZALO } from 'utils/constants';
import { getsaleOrg } from 'utils/localStorageHelper';

const { RangePicker } = DatePicker;


// BÁO CÁO CHI TIẾT ĐÁNH GIÁ CỦA KHÁCH HÀNG GHÉ THĂM SR ====================================================
const createPageDetailRateVisitCustomer = () => {
  return observer(() => {

    //=====================================CHUYỂN NGÔN NGỮ=================================================//
    const { t } = useTranslation();
    const [form] = Form.useForm();


    const [dataReport, setDataReport] = useState<ReportDetailRateVisitCustomerModel[]>([])
    //----------------------------------------- DATA TABLE ------------------------------------------
    const [dataSearch, setDataSearch] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: undefined,
        orderByDesc: undefined,
      },
      env: VARIABLE_CHECK_ZALO,
    });

    // data common date
    const [listCommonDate, setListCommonDate] = useState<CommonModel[]>([]);
    // disable rangePicker khi chọn ngày từ common
    const [disableRangePicker, setDisableRangePicker] = useState(false);

    const [loading, setLoading] = usePartialState({
      loadingSearch: false
    })

    // công ty
    const [listSaleOrg, setListSaleOrg] = useState<CommonModel[]>([]);

    // ============================================================ STATE ==========================================================
    const [reportState, setReportState] = usePartialState({
      loading: false,
    });

    // ---------------XỬ LÝ COLUMN VÀ TABLE-----------------------------------------------------------------------------------------------------
    const columns: ProColumns<ReportDetailRateVisitCustomerModel>[] = [
      {
        title: 'STT',
        dataIndex: 'stt',
        key: 'stt',
        fixed: 'left',
        width: 50,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
        align: 'center',
      },
      // Showroom
      {
        title: 'Showroom',
        dataIndex: 'storeName',
        key: 'storeName',
        fixed: 'left',
        // ellipsis: true,
        width: 200,
      },
      // Nhân viên được đánh giá
      {
        title: 'Nhân viên được đánh giá',
        dataIndex: 'employee',
        key: 'employee',
        // ellipsis: true,
        width: 200,
      },
      // ID lịch
      {
        title: 'ID lịch',
        dataIndex: 'taskCode',
        key: 'taskCode',
        // ellipsis: true,
        width: 150,
      },
      // Mức độ hài lòng
      {
        title: 'Mức độ hài lòng',
        dataIndex: 'mucDoHaiLong',
        key: 'mucDoHaiLong',
        width: 150,
        // onCell: (_, index) => ({
        //   className: 'text-center',
        // }),
      },
      // Vấn đề chưa hài lòng
      {
        title: 'Vấn đề chưa hài lòng',
        dataIndex: 'vanDeChuaHaiLong',
        key: 'vanDeChuaHaiLong',
        width: 300,
        ellipsis: true
      },
      // Phản hồi khác
      {
        title: t('project-report.reply-another'),
        dataIndex: 'phanHoiKhac',
        key: 'phanHoiKhac',
        width: 150,
      },
      // Số điện thoại
      {
        title: t('segment.sdt'),
        dataIndex: 'phone',
        key: 'phone',
        width: 100,
      },
      // Thời gian
      {
        title: 'Thời gian',
        dataIndex: 'responseTime',
        key: 'responseTime',
        width: 150,
        valueType: 'dateTime',
        fieldProps: {
          format: 'DD/MM/YYYY HH:mm:ss',
        },
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      // Mã thiết bị
      {
        title: t('project-report.report-visit-customer.device-code'),
        dataIndex: 'deviceCode',
        key: 'deviceCode',
        // width: 150,
      },
    ];

    // ============================================ ===========================================================================
    const tableRef = useRef<ActionType>();

    const [open, setOpen] = usePartialState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });

    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };


    // Lấy danh sách common date
    const getListCommonDate = async () => {
      setLoading({ loadingSearch: true })
      await commonPresenter.getListSelectCommonDate(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCommonDate(commonStore.commonRespone.data);
      }
      setLoading({ loadingSearch: false })
    };

    // Lấy ngày bằng common data
    const getDateByKey = async (key: string) => {
      setLoading({ loadingSearch: true })
      await commonPresenter.getDateByCommonDate(commonStore, key);
      if (commonStore.commonDate.fromDate) {
        // set value ban đầu chp biến để search báo cáo (ngày tháng)
        setDataSearch({
          ...dataSearch,
          fromTime: commonStore.commonDate.fromDate ? dayjs(commonStore.commonDate.fromDate)?.format(DATE_FORMAT_POST) : undefined,
          toTime: commonStore.commonDate.toDate ? dayjs(commonStore.commonDate.toDate)?.format(DATE_FORMAT_POST) : undefined,
          companyId: form.getFieldValue('companyId'),
        });

        form.setFieldValue("ngayDanhGia", [
          dayjs(commonStore.commonDate.fromDate),
          dayjs(commonStore.commonDate.toDate),
        ]);
      } else {
        form.setFieldValue("ngayDanhGia", undefined);
      }
      setLoading({ loadingSearch: false })
    };


    // Hàm lấy data danh sách công ty =================================================================
    const [listBranch, setListBranch] = useState<CommonModel[]>()
    // const [listCreateBy, setListCreateBy] = useState<CommonModel[]>([]);

    // chi nhánh
    const getListBranch = async (company: string) => {
      await commonPresenter.getBranchByCompany(commonStore, company)
      setListBranch(commonStore.commonRespone.data)
    };

    // Lấy công ty cụ thể theo saleOrg
    const getCompanyBySaleOrg = async () => {
      await reportVisitCustomerSRPresenter.getCompanyBySaleOrg(reportVisitCustomerSRStore, getsaleOrg());

      if (reportVisitCustomerSRStore.companyBySaleOrg.data) {
        form.setFieldValue('companyId', reportVisitCustomerSRStore.companyBySaleOrg.data)

        setDataSearch({
          ...dataSearch,
          companyId: reportVisitCustomerSRStore.companyBySaleOrg.data
        });
      }
    }

    // danh sách công ty
    const getListSaleOrg = async () => {
      await commonPresenter.getListSaleOrg(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListSaleOrg(commonStore.commonRespone.data);
      }
    };

    // Lấy  danh sách người tạo
    // const getListCreateBy = async (key = '') => {
    //   await commonPresenter.getListPersonInCharge(commonStore, key);
    //   if (commonStore.commonRespone.isSuccess) {
    //     setListCreateBy(commonStore.commonRespone.data);
    //   }
    // };
    // const searchCreateBy = useDebounce(getListCreateBy, 500);

    // lấy data báo cáo =============================================================================
    const getDataReport = async (dataSearch: object) => {
      await reportVisitCustomerSRPresenter.getDataReportCTKHGTSR(reportVisitCustomerSRStore, dataSearch);
      if (reportVisitCustomerSRStore.reportCTKHSR.isSuccess) {
        const dataTemp = cloneDeep(reportVisitCustomerSRStore.reportCTKHSR.data);
        setDataReport(dataTemp);
        return dataTemp;
      }
      setDataReport([]);
      return [];
    }


    //================================================================================================
    //================================================================================================
    //================================================================================================
    useEffect(() => {
      (async () => {
        getListSaleOrg();
        // getListCreateBy();
        await getListCommonDate()
        // set value ban đầu
        form.setFieldValue('commonDate', 'LastMonth');
        await getCompanyBySaleOrg();
        await getDateByKey('LastMonth')
        await getListBranch(form.getFieldValue('companyId'))
        setDisableRangePicker(true)

        tableRef.current?.reload();
      })()
    }, [])


    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.report-detail-rate'),
          },
        ]}
        extras={
          <>
            {/* {checkPermission('CREATE') && (
              <div></div>
            )} */}
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <CustomProTable<ReportDetailRateVisitCustomerModel>
            bordered
            columns={columns}
            dataSource={dataReport}
            handleResize={() => { }}
            actionRef={tableRef}
            rowKey="stt"
            scroll={{ x: 1800 }}
            request={async (params = {}, sort, filter) => {
              let data: ReportDetailRateVisitCustomerModel[] = []
              if (dataSearch.fromTime || dataSearch.toTime) {
                data = await getDataReport({
                  ...dataSearch,
                  env: VARIABLE_CHECK_ZALO,
                  paging: {
                    ...dataSearch.paging,
                    orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                    orderByDesc:
                      Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  },
                });
              }

              return {
                data: data,
                success: reportVisitCustomerSRStore.reportCTKHSR.isSuccess,
              };
            }}

            toolBarRender={() => [
              // EXPORT =================================================================
              <CustomButton
                loading={reportState.loading}
                onClick={async () => {
                  setReportState({ loading: true });

                  const { paging, ...rest } = dataSearch
                  await reportVisitCustomerSRPresenter.exportExcelBC1({ ...rest, env: VARIABLE_CHECK_ZALO, })
                  setReportState({ loading: false });
                }}
                icon={<Icon.Download className={'!fill-dark'} />}
              >
                {t('btn.export')}
              </CustomButton>]}

            pagination={{
              ...tablePagination(dataSearch, setDataSearch),
              total: reportVisitCustomerSRStore.reportCTKHSR.paging?.totalCount,
            }}
            options={false}
          />
        </BoxContainer>



        {/* Form search */}
        <SearchBox
          onClose={onClose}
          className="lg:!w-[50%]"
          open={open.openDrawer}
          footer={
            <CustomButton
              htmlType="submit"
              className="my-auto ml-auto"
              loading={loading.loadingSearch}
              type="primary"
              onClick={() => {
                const dateFromTo = form.getFieldValue('ngayDanhGia');
                setDataSearch({
                  ...form.getFieldsValue(),
                  fromTime: dateFromTo && dateFromTo[0] ? dayjs(dateFromTo[0])?.format(DATE_FORMAT_POST) : undefined,
                  toTime: dateFromTo && dateFromTo[1] ? dayjs(dateFromTo[1])?.format(DATE_FORMAT_POST) : undefined,
                  paging: { ...dataSearch.paging, pageIndex: 1 },
                });
                form.submit();
                onClose();
              }}
            >
              {t('btn.search')}
            </CustomButton>
          }
        >
          <SearchForm
            form={form}
            onFinish={(value) => {
              tableRef.current?.reload();
            }}
            column="col-1"
            initialValues={{
              radioGroup: 2,
            }}
          >
            {/* Công ty */}
            <SearchItem name={'companyId'} label={'Công ty'} col2>
              <CustomSelect
                options={listSaleOrg}
                fieldNames={{ label: "value", value: "key" }}
                allowClear
                showSearch
                onChange={async (value, option) => {
                  await getListBranch(value)
                }}
                filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            </SearchItem>
            {/* showroom */}
            <SearchItem name={'storeId'} label={'Showroom'} col2>
              <CustomSelect
                options={listBranch}
                fieldNames={{ label: "value", value: "key" }}
                allowClear
                showSearch
                mode='multiple'
                filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            </SearchItem>
            {/* Ngày đánh giá  */}
            <SearchItem name={"commonDate"} label={"Thời gian"} start col2>
              <CustomSelect
                options={listCommonDate}
                fieldNames={{ label: "value", value: "key" }}
                onChange={async (value, option) => {
                  if (option) {
                    setDisableRangePicker(
                      option.key === "Custom" ? false : true
                    );
                    await getDateByKey(option.key);
                  } else {
                    setDisableRangePicker(false);
                    form.setFieldValue("ngayDanhGia", undefined);
                  }
                }}
                allowClear
              />
            </SearchItem>
            {/* chọn ngày*/}
            <SearchItem name={"ngayDanhGia"} col2>
              <RangePicker
                disabled={disableRangePicker}
                format="DD/MM/YYYY"
                className="w-full"
              />
            </SearchItem>
            {/* user được đánh giá (danh sách tất cả các nhân viên) */}
            {/* <SearchItem name={'employee'} label={'User được đánh giá'} col2>
              <CustomSelect
                options={listCreateBy}
                mode='multiple'
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={false}
                onSearch={(value) => {
                  searchCreateBy(value);
                }}
                allowClear
                showSearch
              />
            </SearchItem> */}
          </SearchForm>
        </SearchBox >
      </PageWrapper >
    )
  })

}

export default createPageDetailRateVisitCustomer